const format = function (num) {
  let prefix = num > 0 ? '+' : ''
  return `${prefix}${num}`
}

const sign = function (value) {
  if (isNaN(value)) {
    return value
  }
  return format(value)
}

export default sign
